module.exports = __webpack_public_path__ + "images/fc1d40839a28da15dcc966a1b49b18f9.svg";